import { Button } from "@mui/material";
import { Flex } from "@zfp-akademie-a-s/zfp-design";
import { BlockedIcon, HomeIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { EmptyPage } from "Components/_Shared/EmptyPage";
import { UnauthenticatedLayout } from "Components/_Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type * as React from "react";

export const Error404Page: React.FunctionComponent = (_) => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={"404"}>
      <EmptyPage
        icon={<BlockedIcon />}
        title={t(Resources.Errors.Error404.Title)}
        subtitle={t(Resources.Errors.Error404.Subtitle)}
        actions={
          <UnstyledLink to="/">
            <Button startIcon={<HomeIcon />} variant="contained">
              {t(Resources.Errors.Error404.Home)}
            </Button>
          </UnstyledLink>
        }
      />
    </UnauthenticatedLayout>
  );
};
